import { createStyles, makeStyles } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey.js';
import React from 'react';
const useStyles = makeStyles(() => createStyles({
  root: {
    top: ({
      dimensions
    }) => dimensions.top,
    left: ({
      dimensions
    }) => dimensions.left,
    width: ({
      dimensions
    }) => dimensions.width,
    height: ({
      dimensions
    }) => dimensions.height,
    position: 'absolute',
    backgroundColor: grey[600],
    opacity: 0.2
  }
}));

/**
 * Return a styled shape
 * @param dimensions Shape dimensions
 * @returns styled shape
 */
export function ShapeDraft({
  dimensions
}) {
  const classes = useStyles({
    dimensions
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    tabIndex: 0,
    key: `draft-${dimensions.height}-${dimensions.width}`
  });
}
//# sourceMappingURL=shape-draft.js.map